import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import type { UserPostProps } from '../types';

interface GetTopicPostParams {
  topicId: number;
  userPostId?: number;
}

export const getTopicPost = ({
  topicId,
  userPostId,
}: GetTopicPostParams): Promise<UserPostProps | undefined> =>
  axios
    .get<{ topic_post: UserPostProps }>(
      userPostId
        ? Routes.topics_topic_post_path(topicId, userPostId)
        : Routes.new_topics_topic_post_path(topicId),
    )
    .then(({ data }) => data.topic_post);
